import React from 'react';
import PropTypes from 'prop-types';
import Placeholder from 'components/common/Placeholder';
import { useTranslation } from 'react-i18next';
import { Paper } from '@mui/material';
import FinancialProductRulesEditDetailsIncomesTableHead from './FinancialProductRulesEditDetailsIncomesTableHead';
import FinancialProductRulesEditDetailsIncomesTableBody from './FinancialProductRulesEditDetailsIncomesTableBody';
import { StyledTable, StyledTableContainer } from 'components/common/Styles';

const FinancialProductRulesEditDetailsIncomesTable = ({
  canWrite,
  incomeList,
  isSaved,
  onAdd,
  onCloseEdit,
  onDelete,
  onSave,
  financialProductRuleIncomeCurrencyList,
  financialProductRuleIncomeTypeList,
  financialProductRuleIncomeValidation
}) => {
  const [t] = useTranslation();

  return (
    <>
      <StyledTableContainer component={Paper}>
        <StyledTable>
          <FinancialProductRulesEditDetailsIncomesTableHead canWrite={canWrite} isSaved={isSaved} onAdd={onAdd} />
          {isSaved && (
            <FinancialProductRulesEditDetailsIncomesTableBody
              canWrite={canWrite}
              incomeList={incomeList}
              onCloseEdit={onCloseEdit}
              onDelete={onDelete}
              onSave={onSave}
              financialProductRuleIncomeCurrencyList={financialProductRuleIncomeCurrencyList}
              financialProductRuleIncomeTypeList={financialProductRuleIncomeTypeList}
              financialProductRuleIncomeValidation={financialProductRuleIncomeValidation}
            />
          )}
        </StyledTable>
      </StyledTableContainer>
      {!isSaved && <Placeholder message={t('FinancialProduct.Details.Rules.Details.PleaseCompleteGeneralData')} color={'warning'} />}
      {isSaved && incomeList?.length === 0 && <Placeholder message={t('TableIsEmpty')} color={'gray'} />}
    </>
  );
};

FinancialProductRulesEditDetailsIncomesTable.propTypes = {
  canWrite: PropTypes.bool.isRequired,
  incomeList: PropTypes.object.isRequired,
  isSaved: PropTypes.bool.isRequired,
  onAdd: PropTypes.func.isRequired,
  onCloseEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  financialProductRuleIncomeCurrencyList: PropTypes.array.isRequired,
  financialProductRuleIncomeTypeList: PropTypes.array.isRequired,
  financialProductRuleIncomeValidation: PropTypes.object.isRequired
};

export default FinancialProductRulesEditDetailsIncomesTable;
